module.exports = __webpack_public_path__ + "static/media/bpharm4.92ed82cb.jpg";